import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import Background from '../../../../providers/BackgroundProvider/Background'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import PersonalSpace from '../../../../components/molecules/PersonalSpace'

const useStyles = makeStyles((theme) => ({
  aiPageLayout: {
    overflowY: 'auto',
    fontWeight: 'normal'
  }
}))

const useVariantStyle = (variant, style) => {
  return useMemo(() => {
    let variantStyle = {}
    if (variant === 'constrained') {
      variantStyle = {
        maxWidth: '1000px',
        margin: '0 auto'
      }
    }

    return {
      ...variantStyle,
      ...(style || {})
    }
  }, [variant, style])
}

function PageLayout ({ variant, children, className, style }) {
  const variantStyle = useVariantStyle(variant, style)
  const classes = useStyles()
  return (
    <Background light='var(--dai-bg)' dark='var(--dai-bg)'>
      <div className={clsx(classes.aiPageLayout, className)}>
        <FadeIn className='px-3 py-2' style={variantStyle}>
          {children}
          <PersonalSpace />
        </FadeIn>
      </div>
    </Background>
  )
}

PageLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['constrained', 'default'])
}

PageLayout.defaultProps = {
  variant: 'default'
}

export default PageLayout
